import FleetModal, { useAsyncModal } from '@/libs/antd/components/Modal';
import FleetTitle from '@/libs/antd/components/Title';
import { useForm } from '@/libs/antd/form';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import rule from '@/libs/antd/rules';
import { MasterData } from '@/libs/fleet-api/services/master-data';
import { NAPRecommendationPayload } from '@/libs/fleet-api/services/nap';
import { Divider, Form, Input, Select } from 'antd';
import { FC } from 'react';

type CovenantCreditForm =
	NAPRecommendationPayload['creditTermsAndConditions'][number];

export const useCovenantCreditModalModal = () => {
	return useAsyncModal<CovenantCreditForm, CovenantCreditForm>();
};

const CovenantCreditModal: FC<
	ReturnType<typeof useCovenantCreditModalModal> & {
		categoryOptions: MasterData[];
		priorityOptions: MasterData[];
	}
> = (props) => {
	const { form, fieldName } = useForm<CovenantCreditForm>();

	return (
		<FleetModal
			{...props.modal}
			width={940}
			closable={false}
			buttonPosition="end"
			okText="SAVE"
			cancelText="BACK"
			onOk={async () => {
				const values = await form.validateFields();
				props.close(values);
			}}
			afterOpenChange={(isOpen) => {
				if (!isOpen) {
					form.resetFields();
				} else if (props.data) {
					form.setFieldsValue(props.data);
				}
			}}
		>
			<FleetTitle>Add Ketentuan & Syarat Kredit</FleetTitle>
			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				form={form}
				labelCol={{ span: 4 }}
				wrapperCol={{ span: 20 }}
			>
				<Form.Item
					name={fieldName('id')}
					noStyle
				/>

				<Form.Item
					label="Syarat"
					style={{ marginTop: 20 }}
					name={fieldName('termAndCondition')}
					rules={[rule.required()]}
				>
					<Input />
				</Form.Item>

				<Divider />

				<Form.Item
					label="Kategori"
					style={{ marginTop: 20 }}
					name={fieldName('categoryId')}
					rules={[rule.required()]}
				>
					<Select
						options={props.categoryOptions.map((data) => {
							return {
								label: data.value,
								value: data.id,
							};
						})}
					/>
				</Form.Item>

				<Divider />

				<Form.Item
					label="Priority"
					style={{ marginTop: 20 }}
					name={fieldName('priorityId')}
					rules={[rule.required()]}
				>
					<Select
						options={props.priorityOptions.map((data) => {
							return {
								label: data.value,
								value: data.id,
							};
						})}
					/>
				</Form.Item>
			</Form>
		</FleetModal>
	);
};

export default CovenantCreditModal;
